import { SingleTableBoxScene } from "@/shared/components/ui";
import { TableReporteVentaEVA } from "../componente";

export default function ReporteVentaPageEVA() {

  return (
    <SingleTableBoxScene
      title="🔎 Reporte de Venta"
    >
      <TableReporteVentaEVA />

    </SingleTableBoxScene>
  )

}